import { useQuery } from '@tanstack/react-query';
import type { Message, ListMessagesResponse } from 'shared';
import { api } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';

export type { Message };

// ─── Query params ─────────────────────────────────────────────────────────────

export interface UseMessagesParams {
  limit?: number;
  offset?: number;
  activeOnly?: boolean;
  currentOnly?: boolean;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

/**
 * GET /api/messages — read-only list of mensagens informativas for participants.
 * Pass `activeOnly: true` so only currently-active messages are returned.
 */
export function useMessages(params: UseMessagesParams = {}) {
  const { limit = 20, offset = 0, activeOnly = false, currentOnly = false } = params;
  const { isAuthenticated, kind } = useAuthStore();

  const qs = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
    ...(activeOnly ? { activeOnly: 'true' } : {}),
    ...(currentOnly ? { currentOnly: 'true' } : {}),
  });

  return useQuery({
    queryKey: ['messages', limit, offset, activeOnly, currentOnly],
    queryFn: () => api.get<ListMessagesResponse>(`/api/messages?${qs}`),
    enabled: isAuthenticated && kind === 'participant',
    staleTime: 1000 * 30,
  });
}
